/*jshint esversion: 6 */

function getCountries() {
  return [
    // {
    //   name: 'Afghanistan',
    //   flag: 'af'
    // },
    // {
    //   name: 'Åland Islands',
    //   flag: 'ax'
    // },
    // {
    //   name: 'Albania',
    //   flag: 'al'
    // },
    // {
    //   name: 'Algeria',
    //   flag: 'dz'
    // },
    // {
    //   name: 'American Samoa',
    //   flag: 'as'
    // },
    // {
    //   name: 'Andorra',
    //   flag: 'ad'
    // },
    // {
    //   name: 'Angola',
    //   flag: 'ao'
    // },
    // {
    //   name: 'Anguilla',
    //   flag: 'ai'
    // },
    // {
    //   name: 'Antarctica',
    //   flag: 'aq'
    // },
    // {
    //   name: 'Antigua and Barbuda',
    //   flag: 'ag'
    // },
    // {
    //   name: 'Argentina',
    //   flag: 'ar'
    // },
    // {
    //   name: 'Armenia',
    //   flag: 'am'
    // },
    // {
    //   name: 'Aruba',
    //   flag: 'aw'
    // },
    // {
    //   name: 'Australia',
    //   flag: 'au'
    // },
    {
      name: 'Austria',
      flag: 'at'
    },
    // {
    //   name: 'Azerbaijan',
    //   flag: 'az'
    // },
    // {
    //   name: 'Bahamas',
    //   flag: 'bs'
    // },
    // {
    //   name: 'Bahrain',
    //   flag: 'bh'
    // },
    // {
    //   name: 'Bangladesh',
    //   flag: 'bd'
    // },
    // {
    //   name: 'Barbados',
    //   flag: 'bb'
    // },
    // {
    //   name: 'Belarus',
    //   flag: 'by'
    // },
    {
      name: 'Belgium',
      flag: 'be'
    },
    // {
    //   name: 'Belize',
    //   flag: 'bz'
    // },
    // {
    //   name: 'Benin',
    //   flag: 'bj'
    // },
    // {
    //   name: 'Bermuda',
    //   flag: 'bm'
    // },
    // {
    //   name: 'Bhutan',
    //   flag: 'bt'
    // },
    // {
    //   name: 'Bolivia (Plurinational State of)',
    //   flag: 'bo'
    // },
    // {
    //   name: 'Bonaire, Sint Eustatius and Saba',
    //   flag: 'bq'
    // },
    // {
    //   name: 'Bosnia and Herzegovina',
    //   flag: 'ba'
    // },
    // {
    //   name: 'Botswana',
    //   flag: 'bw'
    // },
    // {
    //   name: 'Bouvet Island',
    //   flag: 'bv'
    // },
    // {
    //   name: 'Brazil',
    //   flag: 'br'
    // },
    // {
    //   name: 'Virgin Islands (British)',
    //   flag: 'vg'
    // },
    // {
    //   name: 'British Indian Ocean Territory',
    //   flag: 'io'
    // },
    // {
    //   name: 'Brunei Darussalam',
    //   flag: 'bn'
    // },
    {
      name: 'Bulgaria',
      flag: 'bg'
    },
    // {
    //   name: 'Burkina Faso',
    //   flag: 'bf'
    // },
    // {
    //   name: 'Burundi',
    //   flag: 'bi'
    // },
    // {
    //   name: 'Cambodia',
    //   flag: 'kh'
    // },
    // {
    //   name: 'Cameroon',
    //   flag: 'cm'
    // },
    {
      name: 'Canada',
      flag: 'ca'
    },
    // {
    //   name: 'Cabo Verde',
    //   flag: 'cv'
    // },
    // {
    //   name: 'Cayman Islands',
    //   flag: 'ky'
    // },
    // {
    //   name: 'Central African Republic',
    //   flag: 'cf'
    // },
    // {
    //   name: 'Chad',
    //   flag: 'td'
    // },
    // {
    //   name: 'Chile',
    //   flag: 'cl'
    // },
    // {
    //   name: 'China',
    //   flag: 'cn'
    // },
    // {
    //   name: 'Hong Kong',
    //   flag: 'hk'
    // },
    // {
    //   name: 'Macao',
    //   flag: 'mo'
    // },
    // {
    //   name: 'Christmas Island',
    //   flag: 'cx'
    // },
    // {
    //   name: 'Cocos (Keeling) Islands',
    //   flag: 'cc'
    // },
    // {
    //   name: 'Colombia',
    //   flag: 'co'
    // },
    // {
    //   name: 'Comoros',
    //   flag: 'km'
    // },
    // {
    //   name: 'Congo',
    //   flag: 'cg'
    // },
    // {
    //   name: 'Congo, Democratic Republic of the',
    //   flag: 'cd'
    // },
    // {
    //   name: 'Cook Islands',
    //   flag: 'ck'
    // },
    // {
    //   name: 'Costa Rica',
    //   flag: 'cr'
    // },
    // {
    //   name: 'Côte d\'Ivoire',
    //   flag: 'ci'
    // },
    {
      name: 'Croatia',
      flag: 'hr'
    },
    // {
    //   name: 'Cuba',
    //   flag: 'cu'
    // },
    // {
    //   name: 'Curaçao',
    //   flag: 'cw'
    // },
    // {
    //   name: 'Cyprus',
    //   flag: 'cy'
    // },
    {
      name: 'Czechia',
      flag: 'cz'
    },
    {
      name: 'Denmark',
      flag: 'dk'
    },
    // {
    //   name: 'Djibouti',
    //   flag: 'dj'
    // },
    // {
    //   name: 'Dominica',
    //   flag: 'dm'
    // },
    // {
    //   name: 'Dominican Republic',
    //   flag: 'do'
    // },
    // {
    //   name: 'Ecuador',
    //   flag: 'ec'
    // },
    // {
    //   name: 'Egypt',
    //   flag: 'eg'
    // },
    // {
    //   name: 'El Salvador',
    //   flag: 'sv'
    // },
    // {
    //   name: 'Equatorial Guinea',
    //   flag: 'gq'
    // },
    // {
    //   name: 'Eritrea',
    //   flag: 'er'
    // },
    {
      name: 'Estonia',
      flag: 'ee'
    },
    // {
    //   name: 'Ethiopia',
    //   flag: 'et'
    // },
    // {
    //   name: 'Falkland Islands (Malvinas)',
    //   flag: 'fk'
    // },
    // {
    //   name: 'Faroe Islands',
    //   flag: 'fo'
    // },
    // {
    //   name: 'Fiji',
    //   flag: 'fj'
    // },
    {
      name: 'Finland',
      flag: 'fi'
    },
    {
      name: 'France',
      flag: 'fr'
    },
    // {
    //   name: 'French Guiana',
    //   flag: 'gf'
    // },
    // {
    //   name: 'French Polynesia',
    //   flag: 'pf'
    // },
    // {
    //   name: 'French Southern Territories',
    //   flag: 'tf'
    // },
    // {
    //   name: 'Gabon',
    //   flag: 'ga'
    // },
    // {
    //   name: 'Gambia',
    //   flag: 'gm'
    // },
    // {
    //   name: 'Georgia',
    //   flag: 'ge'
    // },
    {
      name: 'Germany',
      flag: 'de'
    },
    // {
    //   name: 'Ghana',
    //   flag: 'gh'
    // },
    // {
    //   name: 'Gibraltar',
    //   flag: 'gi'
    // },
    {
      name: 'Greece',
      flag: 'gr'
    },
    // {
    //   name: 'Greenland',
    //   flag: 'gl'
    // },
    // {
    //   name: 'Grenada',
    //   flag: 'gd'
    // },
    // {
    //   name: 'Guadeloupe',
    //   flag: 'gp'
    // },
    // {
    //   name: 'Guam',
    //   flag: 'gu'
    // },
    // {
    //   name: 'Guatemala',
    //   flag: 'gt'
    // },
    // {
    //   name: 'Guernsey',
    //   flag: 'gg'
    // },
    // {
    //   name: 'Guinea',
    //   flag: 'gn'
    // },
    // {
    //   name: 'Guinea-Bissau',
    //   flag: 'gw'
    // },
    // {
    //   name: 'Guyana',
    //   flag: 'gy'
    // },
    // {
    //   name: 'Haiti',
    //   flag: 'ht'
    // },
    // {
    //   name: 'Heard Island and McDonald Islands',
    //   flag: 'hm'
    // },
    // {
    //   name: 'Holy See',
    //   flag: 'va'
    // },
    // {
    //   name: 'Honduras',
    //   flag: 'hn'
    // },
    {
      name: 'Hungary',
      flag: 'hu'
    },
    // {
    //   name: 'Iceland',
    //   flag: 'is'
    // },
    // {
    //   name: 'India',
    //   flag: 'in'
    // },
    // {
    //   name: 'Indonesia',
    //   flag: 'id'
    // },
    // {
    //   name: 'Iran (Islamic Republic of)',
    //   flag: 'ir'
    // },
    // {
    //   name: 'Iraq',
    //   flag: 'iq'
    // },
    {
      name: 'Ireland',
      flag: 'ie'
    },
    // {
    //   name: 'Isle of Man',
    //   flag: 'im'
    // },
    // {
    //   name: 'Israel',
    //   flag: 'il'
    // },
    {
      name: 'Italy',
      flag: 'it'
    },
    // {
    //   name: 'Jamaica',
    //   flag: 'jm'
    // },
    // {
    //   name: 'Japan',
    //   flag: 'jp'
    // },
    // {
    //   name: 'Jersey',
    //   flag: 'je'
    // },
    // {
    //   name: 'Jordan',
    //   flag: 'jo'
    // },
    // {
    //   name: 'Kazakhstan',
    //   flag: 'kz'
    // },
    // {
    //   name: 'Kenya',
    //   flag: 'ke'
    // },
    // {
    //   name: 'Kiribati',
    //   flag: 'ki'
    // },
    // {
    //   name: 'Korea (Democratic People\'s Republic of)',
    //   flag: 'kp'
    // },
    // {
    //   name: 'Korea, Republic of',
    //   flag: 'kr'
    // },
    // {
    //   name: 'Kuwait',
    //   flag: 'kw'
    // },
    // {
    //   name: 'Kyrgyzstan',
    //   flag: 'kg'
    // },
    // {
    //   name: 'Lao People\'s Democratic Republic',
    //   flag: 'la'
    // },
    // {
    //   name: 'Latvia',
    //   flag: 'lv'
    // },
    // {
    //   name: 'Lebanon',
    //   flag: 'lb'
    // },
    // {
    //   name: 'Lesotho',
    //   flag: 'ls'
    // },
    // {
    //   name: 'Liberia',
    //   flag: 'lr'
    // },
    // {
    //   name: 'Libya',
    //   flag: 'ly'
    // },
    {
      name: 'Liechtenstein',
      flag: 'li'
    },
    {
      name: 'Lithuania',
      flag: 'lt'
    },
    {
      name: 'Luxembourg',
      flag: 'lu'
    },
    // {
    //   name: 'North Macedonia',
    //   flag: 'mk'
    // },
    // {
    //   name: 'Madagascar',
    //   flag: 'mg'
    // },
    // {
    //   name: 'Malawi',
    //   flag: 'mw'
    // },
    // {
    //   name: 'Malaysia',
    //   flag: 'my'
    // },
    // {
    //   name: 'Maldives',
    //   flag: 'mv'
    // },
    // {
    //   name: 'Mali',
    //   flag: 'ml'
    // },
    // {
    //   name: 'Malta',
    //   flag: 'mt'
    // },
    // {
    //   name: 'Marshall Islands',
    //   flag: 'mh'
    // },
    // {
    //   name: 'Martinique',
    //   flag: 'mq'
    // },
    // {
    //   name: 'Mauritania',
    //   flag: 'mr'
    // },
    // {
    //   name: 'Mauritius',
    //   flag: 'mu'
    // },
    // {
    //   name: 'Mayotte',
    //   flag: 'yt'
    // },
    {
      name: 'Mexico',
      flag: 'mx'
    },
    // {
    //   name: 'Micronesia (Federated States of)',
    //   flag: 'fm'
    // },
    // {
    //   name: 'Moldova, Republic of',
    //   flag: 'md'
    // },
    // {
    //   name: 'Monaco',
    //   flag: 'mc'
    // },
    // {
    //   name: 'Mongolia',
    //   flag: 'mn'
    // },
    // {
    //   name: 'Montenegro',
    //   flag: 'me'
    // },
    // {
    //   name: 'Montserrat',
    //   flag: 'ms'
    // },
    // {
    //   name: 'Morocco',
    //   flag: 'ma'
    // },
    // {
    //   name: 'Mozambique',
    //   flag: 'mz'
    // },
    // {
    //   name: 'Myanmar',
    //   flag: 'mm'
    // },
    // {
    //   name: 'Namibia',
    //   flag: 'na'
    // },
    // {
    //   name: 'Nauru',
    //   flag: 'nr'
    // },
    // {
    //   name: 'Nepal',
    //   flag: 'np'
    // },
    {
      name: 'Netherlands',
      flag: 'nl'
    },
    // {
    //   name: 'New Caledonia',
    //   flag: 'nc'
    // },
    // {
    //   name: 'New Zealand',
    //   flag: 'nz'
    // },
    // {
    //   name: 'Nicaragua',
    //   flag: 'ni'
    // },
    // {
    //   name: 'Niger',
    //   flag: 'ne'
    // },
    // {
    //   name: 'Nigeria',
    //   flag: 'ng'
    // },
    // {
    //   name: 'Niue',
    //   flag: 'nu'
    // },
    // {
    //   name: 'Norfolk Island',
    //   flag: 'nf'
    // },
    // {
    //   name: 'Northern Mariana Islands',
    //   flag: 'mp'
    // },
    {
      name: 'Norway',
      flag: 'no'
    },
    // {
    //   name: 'Oman',
    //   flag: 'om'
    // },
    // {
    //   name: 'Pakistan',
    //   flag: 'pk'
    // },
    // {
    //   name: 'Palau',
    //   flag: 'pw'
    // },
    // {
    //   name: 'Palestine, State of',
    //   flag: 'ps'
    // },
    // {
    //   name: 'Panama',
    //   flag: 'pa'
    // },
    // {
    //   name: 'Papua New Guinea',
    //   flag: 'pg'
    // },
    // {
    //   name: 'Paraguay',
    //   flag: 'py'
    // },
    // {
    //   name: 'Peru',
    //   flag: 'pe'
    // },
    // {
    //   name: 'Philippines',
    //   flag: 'ph'
    // },
    // {
    //   name: 'Pitcairn',
    //   flag: 'pn'
    // },
    {
      name: 'Poland',
      flag: 'pl'
    },
    {
      name: 'Portugal',
      flag: 'pt'
    },
    // {
    //   name: 'Puerto Rico',
    //   flag: 'pr'
    // },
    // {
    //   name: 'Qatar',
    //   flag: 'qa'
    // },
    // {
    //   name: 'Réunion',
    //   flag: 're'
    // },
    // {
    //   name: 'Romania',
    //   flag: 'ro'
    // },
    // {
    //   name: 'Russian Federation',
    //   flag: 'ru'
    // },
    // {
    //   name: 'Rwanda',
    //   flag: 'rw'
    // },
    // {
    //   name: 'Saint Barthélemy',
    //   flag: 'bl'
    // },
    // {
    //   name: 'Saint Helena, Ascension and Tristan da Cunha',
    //   flag: 'sh'
    // },
    // {
    //   name: 'Saint Kitts and Nevis',
    //   flag: 'kn'
    // },
    // {
    //   name: 'Saint Lucia',
    //   flag: 'lc'
    // },
    // {
    //   name: 'Saint Martin (French part)',
    //   flag: 'mf'
    // },
    // {
    //   name: 'Saint Pierre and Miquelon',
    //   flag: 'pm'
    // },
    // {
    //   name: 'Saint Vincent and the Grenadines',
    //   flag: 'vc'
    // },
    // {
    //   name: 'Samoa',
    //   flag: 'ws'
    // },
    // {
    //   name: 'San Marino',
    //   flag: 'sm'
    // },
    // {
    //   name: 'Sao Tome and Principe',
    //   flag: 'st'
    // },
    // {
    //   name: 'Saudi Arabia',
    //   flag: 'sa'
    // },
    // {
    //   name: 'Senegal',
    //   flag: 'sn'
    // },
    // {
    //   name: 'Serbia',
    //   flag: 'rs'
    // },
    // {
    //   name: 'Seychelles',
    //   flag: 'sc'
    // },
    // {
    //   name: 'Sierra Leone',
    //   flag: 'sl'
    // },
    // {
    //   name: 'Singapore',
    //   flag: 'sg'
    // },
    // {
    //   name: 'Sint Maarten (Dutch part)',
    //   flag: 'sx'
    // },
    // {
    //   name: 'Slovakia',
    //   flag: 'sk'
    // },
    // {
    //   name: 'Slovenia',
    //   flag: 'si'
    // },
    // {
    //   name: 'Solomon Islands',
    //   flag: 'sb'
    // },
    // {
    //   name: 'Somalia',
    //   flag: 'so'
    // },
    // {
    //   name: 'South Africa',
    //   flag: 'za'
    // },
    // {
    //   name: 'South Georgia and the South Sandwich Islands',
    //   flag: 'gs'
    // },
    // {
    //   name: 'South Sudan',
    //   flag: 'ss'
    // },
    {
      name: 'Spain',
      flag: 'es'
    },
    // {
    //   name: 'Sri Lanka',
    //   flag: 'lk'
    // },
    // {
    //   name: 'Sudan',
    //   flag: 'sd'
    // },
    // {
    //   name: 'Suriname',
    //   flag: 'sr'
    // },
    // {
    //   name: 'Svalbard and Jan Mayen',
    //   flag: 'sj'
    // },
    // {
    //   name: 'Eswatini',
    //   flag: 'sz'
    // },
    {
      name: 'Sweden',
      flag: 'se'
    },
    {
      name: 'Switzerland',
      flag: 'ch'
    },
    // {
    //   name: 'Syrian Arab Republic',
    //   flag: 'sy'
    // },
    // {
    //   name: 'Taiwan, Province of China',
    //   flag: 'tw'
    // },
    // {
    //   name: 'Tajikistan',
    //   flag: 'tj'
    // },
    // {
    //   name: 'Tanzania, United Republic of',
    //   flag: 'tz'
    // },
    // {
    //   name: 'Thailand',
    //   flag: 'th'
    // },
    // {
    //   name: 'Timor-Leste',
    //   flag: 'tl'
    // },
    // {
    //   name: 'Togo',
    //   flag: 'tg'
    // },
    // {
    //   name: 'Tokelau',
    //   flag: 'tk'
    // },
    // {
    //   name: 'Tonga',
    //   flag: 'to'
    // },
    // {
    //   name: 'Trinidad and Tobago',
    //   flag: 'tt'
    // },
    // {
    //   name: 'Tunisia',
    //   flag: 'tn'
    // },
    // {
    //   name: 'Turkey',
    //   flag: 'tr'
    // },
    // {
    //   name: 'Turkmenistan',
    //   flag: 'tm'
    // },
    // {
    //   name: 'Turks and Caicos Islands',
    //   flag: 'tc'
    // },
    // {
    //   name: 'Tuvalu',
    //   flag: 'tv'
    // },
    // {
    //   name: 'Uganda',
    //   flag: 'ug'
    // },
    {
      name: 'Ukraine',
      flag: 'ua'
    },
    // {
    //   name: 'United Arab Emirates',
    //   flag: 'ae'
    // },
    {
      name: 'United Kingdom of Great Britain and Northern Ireland',
      flag: 'gb'
    },
    {
      name: 'United States of America',
      flag: 'us'
    },
    // {
    //   name: 'United States Minor Outlying Islands',
    //   flag: 'um'
    // },
    // {
    //   name: 'Uruguay',
    //   flag: 'uy'
    // },
    // {
    //   name: 'Uzbekistan',
    //   flag: 'uz'
    // },
    // {
    //   name: 'Vanuatu',
    //   flag: 'vu'
    // },
    // {
    //   name: 'Venezuela (Bolivarian Republic of)',
    //   flag: 've'
    // },
    // {
    //   name: 'Viet Nam',
    //   flag: 'vn'
    // },
    // {
    //   name: 'Virgin Islands (U.S.)',
    //   flag: 'vi'
    // },
    // {
    //   name: 'Wallis and Futuna',
    //   flag: 'wf'
    // },
    // {
    //   name: 'Western Sahara',
    //   flag: 'eh'
    // },
    // {
    //   name: 'Yemen',
    //   flag: 'ye'
    // },
    // {
    //   name: 'Zambia',
    //   flag: 'zm'
    // },
    // {
    //   name: 'Zimbabwe',
    //   flag: 'zw'
    // }
  ];
}

function getWorkPackageColors() {
  return [
    'indianred', 'lightcoral', 'salmon', 'darksalmon', 'lightsalmon', 'crimson', 'red', 'firebrick', 'darkred',
    'pink', 'lightpink', 'hotpink', 'deeppink', 'coral', 'tomato', 'orangered', 'darkorange', 'orange', 'amber', 'deep-orange',
    'gold', 'yellow', 'moccasin', 'peachpuff', 'palegoldenrod', 'khaki', 'darkkhaki',
    'lavender', 'thistle', 'plum', 'violet', 'magenta', 'mediumorchid', 'mediumpurple', 'purple', 'deep-purple', 'indigo', 'slateblue', 'darkslateblue',
    'greenyellow', 'chartreuse', 'lime', 'limegreen', 'palegreen', 'mediumspringgreen', 'mediumseagreen', 'seagreen', 'green', 'light-green', 'olive', 'mediumaquamarine', 'lightseagreen',
    'aqua', 'cyan', 'teal', 'steelblue', 'lightsteelblue', 'deepskyblue', 'dodgerblue', 'cornflowerblue', 'mediumslateblue', 'royalblue', 'blue', 'light-blue', 'navy',
    'cornsilk', 'wheat', 'burlywood', 'rosybrown', 'sandybrown', 'goldenrod', 'darkgoldenrod', 'chocolate', 'saddlebrown', 'brown',
    'snow', 'honeydew', 'azure', 'lavenderblush', 'lightslategray', 'silver', 'darkslategray', 'blue-grey'
  ];
}

function getWorkPackageIcons() {
  return [
    "obj-drainage-pipe",
    "obj-floor",
    "obj-roof",
    "obj-steel",
    "obj-brick-wall",
    "obj-drop",
    "obj-plug",
    "obj-plug-2",
    "obj-light-bulb",
    "obj-construction-plan",
    "obj-display",
    "obj-barbell",
    "symbol-electro",
    "symbol-connection",
    "symbol-layer",
    "symbol-link",
    "symbol-resize",
    "symbol-share",
    "symbol-ventilation",
    "obj-phone-mobile",
    "obj-phone",
    "obj-server",
    "obj-traffic-cone",
    "obj-window",
    "sign-radio-waves",
    "human-helmet",
    "human-king",
    "human-stars",
    "human-worker",
    "sign-accessibility",
    "obj-bin",
    "obj-brick-wall-2",
    "obj-brick",
    "obj-bullhorn",
    "obj-camera-2",
    "obj-camera",
    "obj-mic",
    "obj-door",
    "sign-steam",
    "sign-toxic",
    "sign-warning-2",
    "sign-warning",
    "sign-weather-2",
    "sign-weather-3",
    "sign-weather-4",
    "sign-weather",
    "sign-x",
    "sign-attention",
    "sign-fire-2",
    "sign-fire",
    "tool-hammer",
    "tool-paint-bucket",
    "tool-paint-roller",
    "tool-paint-brush",
    "tool-trowel",
    "tool-cutter",
    "tool-paint-roller-2",
    "tool-ruler",
    "tool-wrench",
    "tools-hammer-screwdriver",
    "tools-pipe-wrench-screwdriver",
    "tools-pencil-ruler",
    "tool-screw",
    "obj-clock-2",
    "obj-clock",
    "obj-cog",
    "obj-cogs",
    "obj-package",
    "obj-package-2",
    "obj-package-3",
    "obj-package-4",
    "vehicle-excavator-2",
    "vehicle-truck-delivery-2",
    "vehicle-truck-delivery-3",
    "vehicle-truck-delivery",
    "vehicle-truck-mining",
    "vehicle-truck-mixer",
    "vehicle-crane",
    "vehicle-wheelbarrow",
    "obj-floor-2",
    "obj-floor-3",
    "obj-floor-coating",
    "obj-roof-2",
    "obj-floor-double",
    "obj-plug-3",
    "vehicle-excavator",
    "obj-floor-screed",
    "obj-window-2",
    "obj-radiator",
    "symbol-cold",
    "symbol-ventilation-2",
    "obj-couch",
    "human-king-2",
    "tool-paint-brush-clean",
    "symbol-sanitation",
    "tool-planer",
    "tools-saw-log",
    "obj-t-beam",
    "symbol-stone-cutter",
    "obj-structure",
    "tools-axe-logs",
    "obj-roof-3"
  ];
}

function getValidTaktTimes(){
  return [
    {
      value: 7,
      unit: 'day',
      hashtag: 'TT7D'
    },
    {
      value: 6,
      unit: 'day',
      hashtag: 'TT6D'
    },
    {
      value: 5,
      unit: 'day',
      hashtag: 'TT5D'
    },
    {
      value: 4,
      unit: 'day',
      hashtag: 'TT4D'
    },
    {
      value: 3,
      unit: 'day',
      hashtag: 'TT3D'
    },
    {
      value: 2,
      unit: 'day',
      hashtag: 'TT2D'
    },
    {
      value: 1,
      unit: 'day',
      hashtag: 'TT1D'
    },
    {
      value: 8,
      unit: 'hour',
      hashtag: 'TT8H'
    },
    {
      value: 7,
      unit: 'hour',
      hashtag: 'TT7H'
    },
    {
      value: 6,
      unit: 'hour',
      hashtag: 'TT6H'
    },
    {
      value: 5,
      unit: 'hour',
      hashtag: 'TT5H'
    },
    {
      value: 4,
      unit: 'hour',
      hashtag: 'TT4H'
    },
    {
      value: 3,
      unit: 'hour',
      hashtag: 'TT3H'
    },
    {
      value: 2,
      unit: 'hour',
      hashtag: 'TT2H'
    },
    {
      value: 1,
      unit: 'hour',
      hashtag: 'TT1H'
    },
    {
      value: 60,
      unit: 'minute',
      hashtag: 'TT60M'
    },
    {
      value: 45,
      unit: 'minute',
      hashtag: 'TT45M'
    },
    {
      value: 30,
      unit: 'minute',
      hashtag: 'TT30M'
    },
    {
      value: 15,
      unit: 'minute',
      hashtag: 'TT15M'
    },
    {
      value: 10,
      unit: 'minute',
      hashtag: 'TT10M'
    }
  ];
}


module.exports = {
  getCountries: getCountries,
  getWorkPackageColors: getWorkPackageColors,
  getWorkPackageIcons: getWorkPackageIcons,
  getValidTaktTimes: getValidTaktTimes
};
